// Occurs when blockchain is changed from dropdown in nav or programatically
export const EVENT_PROVIDER_BLOCKCHAIN_CHANGE = 'provider-blockchain-change';
// Occurs when network is changed from mainnet to testnet or vise-versa
export const EVENT_PROVIDER_NETWORK_CHANGE = 'provider-network-change';
// Occurs when assets have finished loading
export const EVENT_USER_ASSETS_LOADED = 'user-assets-loaded';
// Occurs when asset balanecs have finished loading from blockchain
export const EVENT_USER_BALANCES_LOADED = 'user-balances-loaded';